import {RecurrenceMode} from 'nutshell-graphql-types';

import {Stack} from '../../../layout/stack/stack';
import {SelectPickerGeneric} from '../../../select-picker-generic/select-picker-generic';
import {TextField} from '../../../textfield/textfield';
import {Body} from '../../../typography/body';

import {SINGULAR_CYCLE_UNIT_OPTIONS, PLURAL_CYCLE_UNIT_OPTIONS} from './consts';
import type {CycleUnit} from './task-custom-recurrence-popover';

import styles from './task-custom-recurrence-popover.module.css';

type FormState = {
    cycleUnit: CycleUnit;
    cycleValue: number;
};

type FormSetters = {
    setCycleUnit: (cycleUnit: CycleUnit) => void;
    setCycleValue: (cycleValue: number) => void;
};

interface Props {
    mode: RecurrenceMode;
    values: FormState;
    setters: FormSetters;
}

export function RecurrenceCompletionModeForm(props: Props) {
    const isDisabled = props.mode !== RecurrenceMode.COMPLETION;
    const completionCycleUnitOptions =
        props.values.cycleValue === 1 ? SINGULAR_CYCLE_UNIT_OPTIONS : PLURAL_CYCLE_UNIT_OPTIONS;

    return (
        <div className={styles['radio-option-fields']}>
            <Stack spacing={8} isHorizontal={true} alignItems='center'>
                <Body size='small' color={isDisabled ? 'light' : 'medium'}>
                    Due in
                </Body>
                <div style={{width: 65}}>
                    <TextField
                        value={props.values.cycleValue.toString()}
                        onChange={(value) => {
                            props.setters.setCycleValue(Number(value));
                        }}
                        // @ts-expect-error
                        disabled={isDisabled}
                        max='99'
                        min='1'
                        size='small'
                        type='number'
                    />
                </div>
                <div style={{width: 100}}>
                    <SelectPickerGeneric
                        options={completionCycleUnitOptions}
                        value={completionCycleUnitOptions.find(
                            (option) => option.value === props.values.cycleUnit
                        )}
                        // @ts-expect-error
                        onChange={(value) => {
                            props.setters.setCycleUnit(value.value);
                        }}
                        isDisabled={isDisabled}
                        menuPlacement='auto'
                    />
                </div>
            </Stack>
        </div>
    );
}
